export default "__VITE_ASSET__93b01e0d__"